import React from 'react';
import {RichContent, Text} from '../elements/index';


export const BlockQuoteComponent = (props) => {
  const { content } = props;

  const style = {
    backgroundColor: `${ content.color }`,
    color: `${ content.textColor }`
  }
  //Needs refactoring - deeply nested
  return (
    <section className="kiwi-blockquote">
      <div className="container">
        <div className="row">
          <div className="col-xs-12">
            <blockquote className="kiwi-blockquote__quote" style={ style }>
              <RichContent dangerous={content.content} />
            <div className="kiwi-blockquote__quote--author">
              {content.author && <Text content={content.author }/>}
            </div>
            <div className="kiwi-blockquote__quote-author--info">
              {content.additionalText && <Text content={ content.additionalText }/>}
            </div>
            </blockquote>
          </div>
        </div>
      </div>
    </section>
  )
};



// WEBPACK FOOTER //
// src/client/components/common/CMS/components/BlockQuoteComponent.js